import { elapsedSeg } from "@/lib/alarmMeta";

export const PRIO_ORDEN = { alta: 1, media: 2, baja: 3 };

export function slaSeg(a) {
  const s = a.sla || {};
  return a.prioridad === "alta" ? (s.tomar_alta_seg || 60) : (s.tomar_media_seg || 300);
}

export function slaPct(a, nowMs) {
  return elapsedSeg(a.hora_recepcion_servidor, nowMs) / slaSeg(a);
}

// Orden congelado de la cola: ALTA antes que MEDIA; dentro de la misma prioridad, SLA vencido
// primero, luego mayor % consumido, luego mayor antigüedad. NUNCA una MEDIA sobre una ALTA.
export function ordenarCola(alarmas, nowMs) {
  return [...alarmas].sort((a, b) => {
    const pa = PRIO_ORDEN[a.prioridad] || 3, pb = PRIO_ORDEN[b.prioridad] || 3;
    if (pa !== pb) return pa - pb;
    const va = slaPct(a, nowMs), vb = slaPct(b, nowMs);
    const venA = va >= 1 ? 0 : 1, venB = vb >= 1 ? 0 : 1;
    if (venA !== venB) return venA - venB;
    if (vb !== va) return vb - va;
    return (a.hora_recepcion_servidor || "").localeCompare(b.hora_recepcion_servidor || "");
  });
}

export function contarTomadas(alarmas, uid) {
  const mine = alarmas.filter((a) => a.operador_id === uid && a.estado !== "cerrada" && a.estado !== "recibida");
  // Las incidencias técnicas NO cuentan contra los límites de propiedad (protegen la atención de personas).
  const personales = mine.filter((a) => !a.es_tecnica);
  return {
    mias: mine,
    alta: personales.filter((a) => a.prioridad === "alta").length,
    media: personales.filter((a) => a.prioridad === "media").length,
  };
}

